export const EShapeTextAlignHorizontal = wcardinal.ui.EShapeTextAlignHorizontal;